import React, {useEffect} from 'react';
import {getCalApi} from "@calcom/embed-react";
import ContactModal from "../ContactModal";

function Libre1() {

    useEffect(()=>{
        (async function () {
            const cal = await getCalApi({"namespace":"ligne-inclusion"});
            cal("ui", {"styles":{"branding":{"brandColor":"#000000"}},"hideEventTypeDetails":false,"layout":"month_view"});
        })();
    }, [])

    return (
            <section className="libre layout-pt-50 layout-pb-100 text-center">
                <div className="auto-container">
                    <div className="text-center">
                        <h2 className="libre-title">
                            <span>Hotline Handicap</span> spéciale SEEPH 2024<br/>
                            <div style={{fontSize: "30px"}}>Un espace d'échange confidentiel et anonyme</div>
                        </h2>

                        <div className="text mt-15">
                            A l’occasion de la <span>Semaine Européenne de l’Emploi des Personnes Handicapées (SEEPH),
                            Boursorama</span> vous propose un <span>espace d’échange totalement anonyme avec des experts de l’organisme Talents Handicap </span>
                            pour vous renseigner sur le handicap au travail, y compris les maladies chroniques.
                        </div>
                        <h2 className="libre-title mt-2 mb-3">
                            <div style={{fontSize: "30px"}}>Ne manquez pas de réserver votre créneau <span>pour les 19 ou 21 novembre !</span></div>
                        </h2>
                    </div>

                    <ContactModal textButton="Réserver mon créneau avec un expert" showText={false} small="" linkPageContact={false} iframe={true} couleur={true} />
                </div>
            </section>
    );
}

export default Libre1;
